module.exports = __webpack_public_path__ + "static/media/S5.19094bbd.webp";